import type { List } from '@/modules/dashboard/dashboardTypes';
import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';

export const useListsData = () => {
	const [lists] = useSelector<RootState, [Array<List>]>(
		state => [state.dashboard.getIn(['lists', 'data']).toJS()],
		shallowEqual
	);

	return {
		lists
	};
};
